import { render } from "./FormTextbox.vue?vue&type=template&id=dd2687ea"
import script from "./FormTextbox.vue?vue&type=script&lang=js"
export * from "./FormTextbox.vue?vue&type=script&lang=js"

import exportComponent from "D:\\a\\1\\s\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__